import { ApplicationInsights } from '@microsoft/applicationinsights-web'

type TelemetryGlobal = {
  ai?: ApplicationInsights
}

const g = globalThis as typeof globalThis & { __telemetry__?: TelemetryGlobal }
g.__telemetry__ ??= {}

export function getAppInsights(connectionString: string) {
  if (g.__telemetry__?.ai) {
    return g.__telemetry__.ai
  }

  const ai = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
      enableCorsCorrelation: true,
      disableAjaxTracking: true,
      disableFetchTracking: true
    }
  })

  ai.loadAppInsights()

  if (g.__telemetry__) {
    g.__telemetry__.ai = ai
  } else {
    g.__telemetry__ = {
      ai
    }
  }

  return ai
}
